
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dcfqD", function(module, exports) {

$parcel$export(module.exports, "MainButtons", () => $d40d084a9f485409$export$f636d1325d93ee35);
/* MainButtons.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $hArLp = parcelRequire("hArLp");

var $ccHMk = parcelRequire("ccHMk");

var $3gadb = parcelRequire("3gadb");

var $inPa6 = parcelRequire("inPa6");

var $lGgRw = parcelRequire("lGgRw");

var $dTk3A = parcelRequire("dTk3A");

var $5izcQ = parcelRequire("5izcQ");

var $ilxH8 = parcelRequire("ilxH8");

var $dPJCf = parcelRequire("dPJCf");

var $ICFae = parcelRequire("ICFae");

var $dIouf = parcelRequire("dIouf");

var $asQED = parcelRequire("asQED");

var $hFGQl = parcelRequire("hFGQl");

var $eSLr0 = parcelRequire("eSLr0");
var $kxhju = parcelRequire("kxhju");

var $g5Whe = parcelRequire("g5Whe");

var $gaGKC = parcelRequire("gaGKC");

var $6Aos6 = parcelRequire("6Aos6");

var $5EoFB = parcelRequire("5EoFB");

var $bl4QJ = parcelRequire("bl4QJ");

var $eE3dj = parcelRequire("eE3dj");
var $hAnPj = parcelRequire("hAnPj");

var $kz1fW = parcelRequire("kz1fW");

var $glaQ8 = parcelRequire("glaQ8");

var $lTH0u = parcelRequire("lTH0u");

var $h5hpR = parcelRequire("h5hpR");

var $83sfO = parcelRequire("83sfO");

var $3jwuS = parcelRequire("3jwuS");

var $aHcFH = parcelRequire("aHcFH");
var $i49vP = parcelRequire("i49vP");

var $liGyh = parcelRequire("liGyh");

var $cX5ZB = parcelRequire("cX5ZB");

var $f34lU = parcelRequire("f34lU");

var $a3U2R = parcelRequire("a3U2R");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $jIlrR = parcelRequire("jIlrR");

var $8aF6s = parcelRequire("8aF6s");

var $bSvtO = parcelRequire("bSvtO");

var $cMvMc = parcelRequire("cMvMc");

var $9wGTI = parcelRequire("9wGTI");

var $cZa7r = parcelRequire("cZa7r");

var $luv00 = parcelRequire("luv00");

var $5fMeR = parcelRequire("5fMeR");

var $gabmL = parcelRequire("gabmL");

var $gDbO8 = parcelRequire("gDbO8");

var $hfPJk = parcelRequire("hfPJk");

var $lu0E4 = parcelRequire("lu0E4");

var $6mKj3 = parcelRequire("6mKj3");

var $9xGNv = parcelRequire("9xGNv");
const $d40d084a9f485409$var$i18n = (0, $2nPZH.defineMessages)({
    publishExternalShareLabel: {
        id: "editor-main-buttons.editor.publish.external.share.label",
        defaultMessage: "Externally shared"
    },
    publishButtonDisableByEmptyTitleTooltip: {
        id: "editor-main-buttons.editor.buttons.disable.by.empty.title.tooltip",
        defaultMessage: "Your page needs a title before it can be published."
    },
    publishButtonDisableByNotSavingTooltip: {
        id: "editor-main-buttons.editor.buttons.disable.by.not.saving.tooltip",
        defaultMessage: "Still working..."
    },
    publishButtonDisableBySavingTooltip: {
        id: "editor-main-buttons.editor.buttons.disable.by.saving.tooltip",
        defaultMessage: "We\u2019re still saving your page."
    },
    closeButtonText: {
        id: "editor-main-buttons.close.name",
        defaultMessage: "Close"
    },
    closeDraftButtonText: {
        id: "editor-main-buttons.close.draft.name",
        defaultMessage: "Close draft"
    },
    discardDraftButtonText: {
        id: "editor-main-buttons.discard.draft.name",
        defaultMessage: "Discard draft"
    },
    closeButtonPublishTooltip: {
        id: "editor-main-buttons.editor.close.publish.tooltip",
        defaultMessage: "Saves changes without publishing"
    },
    closeButtonUpdateTooltip: {
        id: "editor-main-buttons.editor.close.update.tooltip",
        defaultMessage: "Saves changes without updating"
    },
    discardOnCloseButtonTooltip: {
        id: "editor-main-buttons.editor.discard.close.tooltip",
        defaultMessage: "Discard empty draft"
    },
    editScheduleTooltip: {
        id: "editor-main-buttons.edit.schedule.tooltip",
        defaultMessage: "Edit schedule"
    },
    emptyBlogPostTitleDefault: {
        id: "editor-main-buttons.empty.blogPostTitle",
        defaultMessage: "Untitled blog post"
    },
    emptyPageTitleDefault: {
        id: "editor-main-buttons.empty.default-pageTitle",
        defaultMessage: "Untitled page"
    },
    emptyLivePageTitleDefault: {
        id: "editor-main-buttons.empty.default-livePageTitle",
        defaultMessage: "Untitled live doc"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d40d084a9f485409$var$WebItemWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2hwxutpp",
            __cmplp.className
        ])
    });
});
const $d40d084a9f485409$var$verticalSeparator = (0, $ecnYn.xcss)({
    borderLeft: `2px solid ${"var(--ds-border, #091E4224)"}`,
    display: 'inline-block',
    width: '1px',
    height: '31px',
    marginBlock: `0`,
    marginInline: 'space.075'
});
const $d40d084a9f485409$var$ssrModeSwitcher = (0, $ecnYn.xcss)({
    height: '32px'
});
const $d40d084a9f485409$var$publishButtonDisableReasonToTranslation = {
    'editor.buttons.disable.by.saving.tooltip': 'publishButtonDisableBySavingTooltip',
    'editor.buttons.disable.by.not.saving.tooltip': 'publishButtonDisableByNotSavingTooltip',
    'editor.buttons.disable.by.empty.title.tooltip': 'publishButtonDisableByEmptyTitleTooltip'
};
const $d40d084a9f485409$export$f636d1325d93ee35 = /*#__PURE__*/ (0, $gwFzn.memo)(({ areMainButtonsDisabled: areMainButtonsDisabled, subsequentNode: subsequentNode, publishButtonDisabledReason: publishButtonDisabledReason, precursoryNode: precursoryNode, isPublishDisabled: isPublishDisabled, isPublishDisabledForPublishModal: isPublishDisabledForPublishModal, onClickPublish: onClickPublish, onClose: onClose, onClickPreview: onClickPreview, allowWebItems: allowWebItems, hideShare: hideShare, contentId: contentId, spaceKey: spaceKey, isUnpublishedDraft: isUnpublishedDraftProp, isPublishingContent: isPublishingContent, discardOnCloseEnabled: discardOnCloseEnabled, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, shouldRenderPreview: shouldRenderPreview, flags: flags, saveDraft: saveDraft, useEmbeddedPublishButton: useEmbeddedPublishButton, useEmbeddedPublishModal: useEmbeddedPublishModal, contentType: contentType, title: title, allowInlineComments: allowInlineComments = true, allowStar: allowStar = false, allowWatch: allowWatch = false, allowCopyLink: allowCopyLink = true, allowRestrictions: allowRestrictions = true, allowModeChanger: allowModeChanger = false, viewMode: viewMode, isCloseButtonDisabled: isCloseButtonDisabled })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isUSDExperimentEnabled: isUSDExperimentEnabled } = (0, $hfPJk.useUnifiedShareDialogEligible)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { editorCreateProps: editorCreateProps } = (0, $cZa7r.useAnnotations)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const [isDialogOpen, setDialogState] = (0, $gwFzn.useState)(false);
    const commentButtonRef = (0, $gwFzn.useRef)(null);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)(); // When publishing an unpublished draft, the editor receives the PubSub event from the publish event
    // before the publish animation completes and closes the editor.
    // This causes distracting changes in the MainButtons that we want to stop.
    // To prevent them, we only allow isUnpublishedDraft to be updated when isPublishingContent is false.
    const [isUnpublishedDraft, setIsUnpublishedDraft] = (0, $gwFzn.useState)(isUnpublishedDraftProp);
    (0, $gwFzn.useEffect)(()=>{
        if (!isPublishingContent) setIsUnpublishedDraft(isUnpublishedDraftProp);
    }, [
        isPublishingContent,
        isUnpublishedDraftProp
    ]);
    const [{ unreadCommentsListState: unreadCommentsListState }] = (0, $ICFae.useUnreadComments)();
    const { isCommentsPanelShown: isCommentsPanelShown, hideCommentsPanel: hideCommentsPanel, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const publicLinkData = (0, $gabmL.usePublicLinkPageDataProvider)({
        pageId: contentId,
        fetchPolicy: 'cache-and-network'
    });
    const isPageExternallyShared = !publicLinkData.isLoading && publicLinkData.isPublicLinkFullyEnabled;
    const shouldShowWorldIcon = isPageExternallyShared && !useEmbeddedPublishButton && !((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled);
    const intl = (0, $dBxQj.default)();
    const emptyPageTitleDefault = isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $d40d084a9f485409$var$i18n.emptyLivePageTitleDefault : $d40d084a9f485409$var$i18n.emptyPageTitleDefault;
    const emptyDefaultTitle = contentType === 'blogpost' ? $d40d084a9f485409$var$i18n.emptyBlogPostTitleDefault : emptyPageTitleDefault;
    const publishButtonDisabledTooltip = publishButtonDisabledReason ? intl.formatMessage($d40d084a9f485409$var$i18n[$d40d084a9f485409$var$publishButtonDisableReasonToTranslation[publishButtonDisabledReason]]) : '';
    const getPublishButton = ()=>{
        if (useEmbeddedPublishButton && !(useEmbeddedPublishModal && isUnpublishedDraft)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a3U2R.EmbeddedPublishButton), {
            onClickPublish: onClickPublish,
            publishButtonDisabled: isPublishDisabled || areMainButtonsDisabled,
            savingInProgress: isPublishingContent,
            isUnpublishedDraft: isUnpublishedDraft
        });
        const shouldShowFooterButtons = !(useEmbeddedPublishButton && useEmbeddedPublishModal && isUnpublishedDraft);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kz1fW.PublishButtonWithMoreOptions), {
            onClickPublish: onClickPublish,
            publishButtonDisabled: isPublishDisabledForPublishModal ?? isPublishDisabled,
            title: title,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            userViewingPreview: shouldRenderPreview,
            onClickPreview: onClickPreview,
            isUnpublishedDraft: isUnpublishedDraft,
            flags: flags,
            saveDraft: saveDraft,
            contentType: contentType,
            savingInProgress: !!isPublishingContent,
            shouldShowWorldIcon: shouldShowWorldIcon,
            shouldShowFooterButtons: shouldShowFooterButtons
        });
    };
    const getCloseButtonText = ()=>{
        if ((0, $6mKj3.expValEquals)('confluence_discard_draft_ui_update', 'cohort', 'test')) return intl.formatMessage($d40d084a9f485409$var$i18n.closeButtonText);
        else return discardOnCloseEnabled ? intl.formatMessage($d40d084a9f485409$var$i18n.discardDraftButtonText) : intl.formatMessage(!useEmbeddedPublishButton && isUnpublishedDraft ? $d40d084a9f485409$var$i18n.closeDraftButtonText : $d40d084a9f485409$var$i18n.closeButtonText);
    };
    const getCloseButtonTooltip = ()=>{
        if (areMainButtonsDisabled) return undefined;
        else if (discardOnCloseEnabled) return intl.formatMessage($d40d084a9f485409$var$i18n.discardOnCloseButtonTooltip);
        else if (isUnpublishedDraft) return intl.formatMessage($d40d084a9f485409$var$i18n.closeButtonPublishTooltip);
        else return intl.formatMessage($d40d084a9f485409$var$i18n.closeButtonUpdateTooltip);
    };
    const CloseButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: getCloseButtonTooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
            id: "close-button",
            "data-test-id": "close-button",
            appearance: "subtle",
            onClick: onClose,
            isDisabled: isCloseButtonDisabled
        }, getCloseButtonText()));
    const copyLinkButtonSource = {
        source: 'editToolbar'
    };
    const getShareButton = ({ contentSubType: contentSubType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, (0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lTH0u.ShareAndRestrictButton), {
            contentId: contentId,
            contentType: contentType,
            contentSubType: contentSubType,
            shareeAction: "view",
            allowRestrictions: allowRestrictions,
            ...copyLinkButtonSource
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $glaQ8.ShareButton), {
            contentId: contentId,
            contentSubType: contentSubType || undefined,
            shareeAction: "view",
            shareTitle: title || intl.formatMessage(emptyDefaultTitle)
        }));
    const checkUnsavedAndHandleCommentButtonClick = ()=>{
        // With the way the editor annotation provider works, it will show BOTH the the view components
        // at the same time, so if the create component is shown, ignore any changes and just trigger
        // the button press to select thefirst (or first unread) comment and let the closing of the create
        // flow handle the content changed checks and reset the changed values, this will only handle view
        if (!editorCreateProps && hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                handleCommentIconClickInEditor();
            }
        });
        else handleCommentIconClickInEditor();
    };
    const handleCommentIconClickInEditor = ()=>{
        if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
            if (isCommentsPanelShown) hideCommentsPanel();
            else showCommentsPanel();
            return;
        }
        const firstComment = document.querySelector('.ak-editor-annotation-focus,.ak-editor-annotation-blur,.ak-editor-block-annotation-focus,.ak-editor-block-annotation-blur');
        if (unreadCommentsListState?.length) {
            const unreadMarkerRefsListState = unreadCommentsListState?.filter((unreadComment)=>Boolean(unreadComment.threadKey)).map((unreadComment)=>unreadComment.threadKey);
            const sortedUnreadMarkerRefList = (0, $aHcFH.getSortedMarkerRefs)(unreadMarkerRefsListState, 'edit');
            const unreadCommentMarkerRef = sortedUnreadMarkerRefList[0];
            const firstUnreadComment = document.getElementById(unreadCommentMarkerRef);
            (0, $i49vP.openInlineCommentInEditor)(firstUnreadComment, unreadCommentMarkerRef);
            setQueryParams({
                unreadCommentMark: unreadCommentMarkerRef,
                focusedCommentId: undefined
            });
        } else {
            if (firstComment) {
                setDialogState(false);
                const firstCommentID = firstComment?.closest('[data-mark-annotation-type="inlineComment"]')?.id ?? '';
                (0, $i49vP.openInlineCommentInEditor)(firstComment, firstCommentID);
            } else setDialogState(!isDialogOpen);
            removeCommentQueryParams();
        }
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'inlineCommentsIcon',
                attributes: {
                    pageHasInlineComments: !!firstComment,
                    icontype: 'header',
                    context: 'default',
                    newState: 'showComments',
                    unreadCommentCount: unreadCommentsListState?.length
                },
                objectType: 'page',
                objectId: contentId,
                source: 'editPageScreen'
            }
        }).fire();
    };
    const getCommentIcon = (triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cX5ZB.CommentIconLoadable), {
            triggerProps: triggerProps,
            intl: intl,
            handleCommentButtonClick: (0, $9wGTI.fg)('confluence_frontend_editor_annotation_manager') ? checkUnsavedAndHandleCommentButtonClick : handleCommentIconClickInEditor,
            commentButtonRef: commentButtonRef,
            isDisabled: areMainButtonsDisabled,
            contentId: contentId,
            pageMode: "edit"
        });
    };
    const webItems = [];
    if (allowWebItems) webItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d40d084a9f485409$var$WebItemWrapper, {
        "data-test-id": "editor-precursor-buttons-wrapper",
        key: webItems.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kxhju.WebItemLocation), {
        key: "precursor-buttons",
        tagName: "span",
        contentId: contentId,
        location: (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS),
        style: {
            display: 'flex'
        },
        renderWhenLoading: true
    }, // By default, there should be one web item, the restrictions web item. Additional web items may exist on tenants with Connect apps.
    ({ loading: loading, webItems: loadedWebItems })=>{
        // If we're a live page and there are no web items (e.g. live view), we still always want to show the default buttons.
        if (loading || !loadedWebItems.length && !isLivePage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, allowModeChanger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $d40d084a9f485409$var$ssrModeSwitcher
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gDbO8.LivePagesModeChanger), {
            contentId: contentId,
            isDisabled: true,
            flags: flags
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jIlrR.CommentButtonPlaceholder), null), allowStar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gaGKC.FavouriteButtonPlaceholder), null), allowWatch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bl4QJ.WatchButtonPlaceholder), null), !((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null), !((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h5hpR.CopyLinkButtonPlaceholder), null));
         // The restrictions button is rendered via <RestrictionsDialogTriggerWrapper> instead of as a web item, to fix positioning issue CCP-871.
        // If in view mode (live view), do not render any web items as they are intended for users editing the page.
        const filteredWebItems = loading || viewMode ? [] : loadedWebItems.filter(({ id: id })=>id !== (0, $hFGQl.EDIT_PAGE_METADATA_RESTRICTIONS_ID));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, allowModeChanger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gDbO8.LivePagesModeChanger), {
            contentId: contentId,
            isDisabled: !!areMainButtonsDisabled,
            flags: flags,
            analyticsSource: "livePageScreen"
        }), allowInlineComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).COLLABORATION
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
            isOpen: isDialogOpen,
            content: (0, $f34lU.inlineCommentGifContent),
            trigger: (triggerProps)=>getCommentIcon(triggerProps),
            placement: (0, $cX5ZB.getPlacement)(commentButtonRef.current),
            onClose: ()=>{
                setDialogState(false);
            },
            zIndex: (0, $dTk3A.layers).flag(),
            shouldRenderToParent: true
        })), allowStar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g5Whe.LazyFavouriteButton), {
            key: "favourite-button",
            contentId: contentId,
            isDisabled: areMainButtonsDisabled
        }), allowWatch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6Aos6.LazyDialogWrapperLoader), {
            key: "watch-dialog",
            contentId: contentId,
            defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE,
            componentLocation: (0, $6Aos6.WATCH_DIALOG_LOCATION).PAGE,
            isDisabled: areMainButtonsDisabled
        }), allowRestrictions && !((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE,
            key: "restrictions-dialog-editor-trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
            name: "live-pages-changeboarding.restrictions"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hAnPj.RestrictionsDialogTriggerWrapper), {
            contentId: contentId,
            triggeredFrom: "fromEdit",
            isDisabled: areMainButtonsDisabled
        }))), allowCopyLink && !((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $glaQ8.CopyLinkButtonLoader), {
            contentId: contentId,
            contentType: contentType,
            pageMode: "edit",
            source: "editToolbar",
            spaceKey: spaceKey
        }), filteredWebItems.length && !isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $asQED.WebItemList), {
            id: "editor-precursor-buttons",
            dataTestId: "editor-metadata-web-items",
            webItems: filteredWebItems
        })) : null);
    })));
     // Live pages render share button instead of publish and close buttons
    if (isLivePage) {
        const shareButton = getShareButton({
            contentSubType: (0, $83sfO.LIVE_PAGE_SUBTYPE)
        });
        const livePagesButtonGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
            name: (0, $ilxH8.LIVE_DOC_SHARE_BUTTON_TARGET)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hArLp.default), null, shareButton));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9xGNv.MainButtonContainer), {
            "data-vc": "editor-main-buttons-container",
            ...ssrPlaceholderIdProp
        }, webItems, precursoryNode || null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
            name: "live-pages-changeboarding.share-button"
        }, livePagesButtonGroup), subsequentNode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9xGNv.SubsequentNodeWrapper), {
            "data-test-id": "subsequent-node-wrapper"
        }, subsequentNode) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ilxH8.LiveDocSpotlightsTour), null));
    } else {
        const publishButton = getPublishButton();
        const publishButtonGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hArLp.default), null, publishButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(CloseButton, null));
        const preloadedPublishButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lu0E4.PreloadButtonWrapper), {
            isPublish: true,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }, publishButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lu0E4.PreloadButtonWrapper), {
            isPublish: false,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(CloseButton, null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9xGNv.MainButtonContainer), {
            "data-vc": "editor-main-buttons-container",
            ...ssrPlaceholderIdProp
        }, webItems, precursoryNode || null, areMainButtonsDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: publishButtonDisabledTooltip,
            position: "bottom"
        }, publishButtonGroup) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, preloadedPublishButton), accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS && !hideShare && ((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $d40d084a9f485409$var$verticalSeparator
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lTH0u.ShareAndRestrictButton), {
            contentId: contentId,
            contentType: contentType,
            shareeAction: "edit",
            allowRestrictions: allowRestrictions,
            isUnpublishedDraft: isUnpublishedDraft,
            ...copyLinkButtonSource
        })), subsequentNode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9xGNv.SubsequentNodeWrapper), {
            "data-test-id": "subsequent-node-wrapper"
        }, subsequentNode) : null);
    }
});

});
parcelRegister("a3U2R", function(module, exports) {

$parcel$export(module.exports, "EmbeddedPublishButton", () => $3b24b72eb8df52e1$export$29d8ecea5ac14980);
/* EmbeddedPublishButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $9YwaJ = parcelRequire("9YwaJ");

var $6F6hl = parcelRequire("6F6hl");

var $idqcs = parcelRequire("idqcs");

var $ljm2R = parcelRequire("ljm2R");
const $3b24b72eb8df52e1$var$PUBLISH_HOTKEY_DESCRIPTION_ID = 'publish-hotkey-description';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b24b72eb8df52e1$var$ButtonWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $3b24b72eb8df52e1$var$i18n = (0, $2nPZH.defineMessages)({
    publishButtonText: {
        id: "embedded-publish-button.publish-button-text",
        defaultMessage: "Publish"
    },
    updateButtonText: {
        id: "embedded-publish-button.update-button-text",
        defaultMessage: "Update"
    },
    publishHotkeyDescription: {
        id: "embedded-publish-button.publish-hotkey-description",
        defaultMessage: "To publish this content, select {keyCombination} on your keyboard."
    }
});
const $3b24b72eb8df52e1$export$29d8ecea5ac14980 = ({ onClickPublish: onClickPublish, publishButtonDisabled: publishButtonDisabled, savingInProgress: savingInProgress, isUnpublishedDraft: isUnpublishedDraft })=>{
    const intl = (0, $dBxQj.default)();
    const publishButtonText = isUnpublishedDraft ? intl.formatMessage($3b24b72eb8df52e1$var$i18n.publishButtonText) : intl.formatMessage($3b24b72eb8df52e1$var$i18n.updateButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $idqcs.TooltipWithShortcut), {
        shortcutAccelerator: (0, $ljm2R.EDITOR2_SHORTCUTS).PUBLISH,
        shortcutListener: onClickPublish({
            suppressNotifyWatchers: false
        }),
        position: "bottom",
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6F6hl.default), {
        id: $3b24b72eb8df52e1$var$PUBLISH_HOTKEY_DESCRIPTION_ID,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-test-id": "publish-screen-reader-hotkey-description"
    }, intl.formatMessage($3b24b72eb8df52e1$var$i18n.publishHotkeyDescription, {
        keyCombination: (0, $ljm2R.getShortcutString)((0, $ljm2R.EDITOR2_SHORTCUTS).PUBLISH, intl.formatMessage)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3b24b72eb8df52e1$var$ButtonWrapper, {
        "data-test-id": "publish-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9YwaJ.default), {
        id: "publish-button",
        "data-test-id": "publish-button-ui",
        appearance: "primary",
        onClick: onClickPublish({
            suppressNotifyWatchers: false
        }),
        isDisabled: !savingInProgress && publishButtonDisabled,
        "aria-describedby": $3b24b72eb8df52e1$var$PUBLISH_HOTKEY_DESCRIPTION_ID,
        isLoading: savingInProgress
    }, publishButtonText)));
};

});

parcelRegister("9xGNv", function(module, exports) {

$parcel$export(module.exports, "MainButtonContainer", () => $f479113e913bb347$export$9d50784561433df2);
$parcel$export(module.exports, "SubsequentNodeWrapper", () => $f479113e913bb347$export$7170ce74378ea9bb);
/* MainButtonStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $f479113e913bb347$export$9d50784561433df2 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4cvr1h6o _1e0c1txw _u5f31ejb _1o9zidpf _kqswh2mm _1pbyki9h",
            __cmplp.className
        ])
    });
});
const $f479113e913bb347$export$7170ce74378ea9bb = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});



//# sourceMappingURL=MainButtons.f0c29188.js.map
